import "./Hero.css";
import logo from "../../assets/img/logogoldnobgcrop.png";
import DataFetcher from "../../hooks/useDataFetcher";
import { useEffect, useState } from "react";

export default function Hero() {
  const [hero, setHero] = useState({
    title: "GYK Hukuk Sizlerle",
    subtitle: "Sizlerleyiz gerçekten",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac justo euismod, cursus libero nec, tincidunt nunc. Nullam euismod, odio nec bibendum varius, urna nunc ultrices justo, vel tincidunt metus libero vel nunc.",
    heroImg: logo,
  });
  const loading = false;
  const error = null;
  // const { data, loading, error } = DataFetcher(
  //   "http://localhost:5000/api/StaticPagesInfoes"
  // );
  // useEffect(() => {
  //   if (data !== null && loading === false && error === null) {
  //     setHero({
  //       title: data.heroHeader,
  //       subtitle: data.heroSubheader,
  //       description: data.heroText,
  //       heroImg: data.heroImg,
  //     });
  //   }
  // }, [data, loading, error]);
  return (
    <>
      {loading && <h1>Loading...</h1>}
      {error && null}
      {!loading && !error && (
        <>
          <section className="hero">
            <article className="hero-text">
              <h1>{hero.title}</h1>
              <h2>{hero.subtitle}</h2>
              <p>{hero.description}</p>
            </article>

            <img
              src={hero.heroImg}
              loading="lazy"
              alt=""
              width={310}
              height={596}
            ></img>
          </section>
        </>
      )}
    </>
  );
}
